import { Grid, Stack } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

import { CredentialTextField } from '../TextFields/CredentialTextField';
import NodeSection from '../../../NodeUI/NodeSection';
import ApiKeySecretsField from '../ApiKeySecretsField';
import SecretsPlaceholderField from '../SecretsPlaceholderField';
import { CREDENTIAL } from '../../CredentialConstants';

const Variable = ({
  credential,
  onChange,
  onSecretValueValidationChange,
  credentialStatus,
  hasInteractedWithSecret,
  showPasswordField,
  onInteractedWithSecret,
  onShowPasswordField,
}) => {
  useEffect(() => {
    const isInvalid =
      hasInteractedWithSecret && (!credential.secretValue || credential.secretValue.trim() === '');
    onSecretValueValidationChange(!isInvalid);
  }, [credential.secretValue, hasInteractedWithSecret, onSecretValueValidationChange]);

  return (
    <Stack spacing={2}>
      <NodeSection title="Details">
        <CredentialTextField
          label={CREDENTIAL.LABELS.DISPLAY_NAME}
          placeholder={CREDENTIAL.PLACEHOLDERS.DISPLAY_NAME}
          value={credential.name}
          onChange={e => onChange(CREDENTIAL.FIELD_KEYS.NAME, e.target.value)}
        />
        <CredentialTextField
          label={CREDENTIAL.LABELS.DESCRIPTION}
          placeholder={CREDENTIAL.PLACEHOLDERS.DESCRIPTION}
          value={credential.description}
          onChange={e => onChange(CREDENTIAL.FIELD_KEYS.DESCRIPTION, e.target.value)}
          minRows={4}
          multiline
        />
      </NodeSection>

      <NodeSection title="Placeholder">
        <Grid container>
          <SecretsPlaceholderField
            label={CREDENTIAL.LABELS.PLACEHOLDER}
            instructionText={CREDENTIAL.MESSAGES.PLACEHOLDER_INSTRUCTION}
            value={credential.placeholder}
            onChange={onChange}
            error={!credential.placeholder}
            placeholderText={CREDENTIAL.PLACEHOLDERS.PLACEHOLDER}
            emptyFieldMessage={CREDENTIAL.MESSAGES.EMPTY_FIELD}
            fieldKey={CREDENTIAL.FIELD_KEYS.PLACEHOLDER}
          />
        </Grid>
      </NodeSection>

      <NodeSection title="Secret value">
        <ApiKeySecretsField
          label={CREDENTIAL.LABELS.VALUE}
          instructionText={CREDENTIAL.MESSAGES.SECRET_INSTRUCTION}
          secretFieldName={CREDENTIAL.FIELD_KEYS.SECRET_VALUE}
          value={credential.secretValue}
          onChange={val => onChange(CREDENTIAL.FIELD_KEYS.SECRET_VALUE, val)}
          placeholder={CREDENTIAL.PLACEHOLDERS.SECRET_VALUE}
          errorMessage={CREDENTIAL.MESSAGES.EMPTY_FIELD}
          credentialStatus={credentialStatus}
          showPasswordField={showPasswordField}
          hasInteractedWithSecret={hasInteractedWithSecret}
          onShowPasswordField={onShowPasswordField}
          onInteractedWithSecret={onInteractedWithSecret}
        />
      </NodeSection>
    </Stack>
  );
};

Variable.propTypes = {
  credential: PropTypes.shape({
    name: PropTypes.string.isRequired,
    secretValue: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired,
    status: PropTypes.string,
  }),
  onChange: PropTypes.func.isRequired,
  onSecretValueValidationChange: PropTypes.func.isRequired,
  credentialStatus: PropTypes.string.isRequired,
  hasInteractedWithSecret: PropTypes.bool.isRequired,
  showPasswordField: PropTypes.bool.isRequired,
  onInteractedWithSecret: PropTypes.func.isRequired,
  onShowPasswordField: PropTypes.func.isRequired,
};

export default Variable;
